import { Injectable } from '@angular/core';
import { Player } from 'fl-player-interface';
import { PlayerInfo } from './../model/newrelic.model';

@Injectable({
  providedIn: 'root',
})
export class NewrelicPlayerStore {
  private playerInstance: Player;

  public setPlayerInstance(playerInstance: Player): void {
    this.playerInstance = playerInstance;
  }

  public getPlayerInfo(): PlayerInfo {
    return {
      playerName: this?.playerInstance?.internalPlayerName,
    };
  }
}
